<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
    	
    	<el-form :inline="true" class="backborder1 demo-form-inline" size="small">
	        <el-form-item style="width:12%">
	            <el-date-picker v-model="query.start" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%" @change="isselect=true"></el-date-picker>
	        </el-form-item>
	        <el-form-item style="width:12%">
	            <el-date-picker v-model="query.end" type="date" placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%" @change="isselect=true"></el-date-picker>
	        </el-form-item>
	        <el-form-item>
	        	<el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
	        	<el-button round size="mini" class="menubutton" @click="getsalestypedata(1)">今日</el-button>
	        	<el-button round size="mini" class="menubutton" @click="getsalestypedata(2)">昨日</el-button>
	        	<el-button round size="mini" class="menubutton" @click="getsalestypedata(3)">本月</el-button>
	        	<el-button round size="mini" class="menubutton" @click="getsalestypedata(4)">本年</el-button>
	  		</el-form-item>
	  		<el-form-item style="float:right">
	  			<el-button type="primary" @click="checkflow">查看经营流水</el-button>
	  		</el-form-item>
	  	</el-form>
	  	
	  	<!----------销售情况------------------>
	  	<div class="salesmain" style="margin-top:10px" v-loading="saleLoading">
	  		<div class="bordertitle">
			  	<img src="../../static/images/saleicon1.png"/>
				<span>销售情况</span>			  
			</div>
	  		<div class="bordermain">
	  			<div class="single">
				  	<el-tooltip placement="top">
						<div slot="content">销售出库单（状态：已完成）实付金额合计，<br/>包括未付款、已付款的订单</div>
						<span>{{saledatas.sells.amount}} <i>{{saledatas.sells.unit}}</i></span>
					</el-tooltip>
	  				<p>销售（{{saledatas.sells.nums}}笔）</p>
	  			</div>
	  			<div class="double">
	  				<table style="padding:16% 0 16% 0">
	  					<tr>
						  	<td align="left">
							  	<el-tooltip placement="top">
									<div slot="content">截止当前时间内首次下单的客户</div>
									<i class="firstcustomer">首客</i>
								</el-tooltip>
							</td>
							<td align="left">首客（{{saledatas.first.nums}}家）</td><td align="left" style="color:#606266">{{saledatas.first.amount}}{{saledatas.first.unit}}</td></tr>
	  					
	  				</table>
	  			</div>
	  			<div class="double">
	  				<table style="padding:16% 0 16% 0">
	  					<tr>
						  	<td align="left">
							  	<el-tooltip placement="top">
									<div slot="content">截止当前时间内下单次数超过1次的客户</div>
							  		<i class="secondcustomer">回购</i>
								</el-tooltip>
							</td>
							<td align="left">回购（{{saledatas.again.nums}}家）</td><td align="left" style="color:#606266">{{saledatas.again.amount}}{{saledatas.again.unit}}</td></tr>
	  				</table>
	  			</div>
	  			<div class="single">
				  	<el-tooltip placement="top">
						<div slot="content">指定时间内商品退货单（状态：已完成）退款金额合计</div>
	  					<span>{{saledatas.refund.amount}} <i>{{saledatas.refund.unit}}</i></span>
					</el-tooltip>
	  				<p>退货金额（{{saledatas.refund.nums}}笔）</p>
	  			</div>
	  			<div class="single" style="border-left:1px solid #EBEEF5">
				  	<el-tooltip placement="top">
						<div slot="content">指定时间内销售出库单（状态：已完成）实付金额-成本合计</div>
	  					<p style="margin-top:11%">毛利&nbsp;&nbsp;&nbsp;&nbsp;<h style="color:#606266">{{saledatas.gross.amount}}{{saledatas.gross.unit}}</h></p>
	  				</el-tooltip>
					<el-tooltip placement="top">
						<div slot="content">指定时间内销售出库单（状态：已完成）实付金额-成本合计/实付金额*100</div>
						<p style="margin-top:0;line-height:18px">毛利率&nbsp;&nbsp;&nbsp;&nbsp;<h style="color:#606266">{{saledatas.gross.percent}}</h></p>
	  				</el-tooltip>
				</div>
	  		</div>
	  	</div>
	  	
	  	<!---------收款情况------------->
	  	<div class="salesmain" style="margin-top:10px" v-loading="getLoading">
	  		<div class="bordertitle"><img src="../../static/images/saleicon2.png"/><span>收款情况</span></div>
	  		<div class="bordermain">
	  			<div class="single" style="width:18%">
				  	<el-tooltip placement="top">
						<div slot="content">指定时间内所收款结算金额（销售出库单结算金额、预存款充值金额）合计</div>
	  					<span>{{incomedata.all.amount}} <i>{{incomedata.all.unit}}</i></span>
					</el-tooltip>
	  				<p>收款（{{incomedata.all.nums}}笔）</p>
	  			</div>
	  			<div class="double" style="width:25%">
				  	<el-tooltip placement="top">
						<div slot="content">指定时间预存款充值金额合计</div>
	  					<p>收预存款（{{incomedata.deposit.nums}}）笔&nbsp;&nbsp;&nbsp;&nbsp;<i>{{incomedata.deposit.amount}}{{incomedata.deposit.unit}}</i></p>
					</el-tooltip>
	  				<div class="percent"><h :style="{width:incomedata.deposit.percent}"></h></div>
	  				<em>{{incomedata.deposit.percent}}</em>
	  			</div>
	  			<div class="double" style="width:25%">
				  	<el-tooltip placement="top">
						<div slot="content">指定时间内销售出库单（状态：已完成）实付金额结算合计</div>
	  					<p>当日开单当日收款（{{incomedata.sell.nums}}）笔&nbsp;&nbsp;&nbsp;&nbsp;<i>{{incomedata.sell.amount}}{{incomedata.sell.unit}}</i></p>
	  				</el-tooltip>
					<div class="percent"><h :style="{width:incomedata.sell.percent}"></h></div>
	  				<em>{{incomedata.sell.percent}}</em>
	  			</div>
	  			<div class="double" style="width:25%">
				  	<el-tooltip placement="top">
						<div slot="content">往期所开销售出库单（状态：已完成）<br/>在指定时间内实付金额结算合计</div>
	  					<p>欠款回收（{{incomedata.fund.nums}}）笔&nbsp;&nbsp;&nbsp;&nbsp;<i>{{incomedata.fund.amount}}{{incomedata.fund.unit}}</i></p>
	  				</el-tooltip>
					<div class="percent"><h :style="{width:incomedata.fund.percent}"></h></div>
	  				<em>{{incomedata.fund.percent}}</em>
	  			</div>
	  		</div>
	  	</div>
	  	
	  	<!---------欠货两清------------->
	  	<div class="moneymain" style="margin-top:10px" v-loading="emptyLoading">
	  		<div class="bordertitle"><img src="../../static/images/saleicon3.png"/><span>钱货两清</span></div>
	  		<div class="bordermain1">
	  			<div class="left" style="background:#67C23A">
	  				<span style="font-weight:bold">{{emptyaccounts.allcount}}&nbsp;<i>笔</i></span>
	  				<span style="font-size:14px;margin-top:5px">钱货两清</span>
	  			</div>
	  			<div class="right">
				  	<el-tooltip placement="top">
						<div slot="content">指定时间之内所开销售出库单（状态：已完成）<br/>实付金额结清订单数合计</div>
	  					<span>当日两清单据&nbsp;&nbsp;<i>{{emptyaccounts.news}}笔</i></span>
					</el-tooltip>
					<el-tooltip placement="top">
						<div slot="content">往期所开销售出库单（状态：已完成）<br/>在指定时间内实付金额结清订单数合计</div>
						<span>以往单据两清&nbsp;&nbsp;<i>{{emptyaccounts.old}}笔</i></span>
					</el-tooltip>
	  			</div>
	  		</div>
	  	</div>
	  	
	  	<!---------欠货未清------------->
	  	<div class="moneymain" style="float:right;margin-top:10px" v-loading="noemptyLoading">
	  		<div class="bordertitle"><img src="../../static/images/saleicon4.png"/><span>钱货未清（截止到当前时间）</span></div>
	  		<div class="bordermain1">
	  			<div class="left" style="background:#F56C6C">
	  				<span style="font-weight:bold">{{noemptyaccounts.allcount}}&nbsp;<i>笔</i></span>
	  				<span style="font-size:14px;margin-top:5px">钱货未清</span>
	  			</div>
	  			<div class="right">
				  	<el-tooltip placement="top">
						<div slot="content">往期所开销售出库单（状态：已完成）<br/>在指定时间内实付金未结清订单数合计</div>
	  					<span>到期未收款，已出库&nbsp;&nbsp;<i>{{noemptyaccounts.news}}笔</i></span>
					</el-tooltip>
					<!--  
	  				<span>已收款，未出库&nbsp;&nbsp;<i>{{noemptyaccounts.old}}笔</i></span>
					-->
	  			</div>
	  		</div>
	  	</div>
	  	
	  	<!------------ 经营流水 ------------->
	  	<el-dialog title="经营流水" :visible.sync="flowDialog" width="92%" top="5vh">
	  		<el-form :inline="true" class="demo-form-inline" size="small">
		        <el-form-item style="width:12%">
		            <el-select v-model="flowquery.flowtype" filterable remote reserve-keyword @change="changedate">
		          		<el-option v-for="(item,index) in flowtype" :key="index" :label="item.name" :value="item.id"></el-option>
		        	</el-select> 
		        </el-form-item>
		        
		        <!-------按日期查找-------------->
		        <el-form-item style="width:15%" v-if="flowquery.flowtype==3">
		            <el-date-picker v-model="flowquery.start" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%" @change="flowselect=true"></el-date-picker>
		        </el-form-item>
		        <el-form-item style="width:15%" v-if="flowquery.flowtype==3">
		            <el-date-picker v-model="flowquery.end" type="date" placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%" @change="flowselect=true"></el-date-picker>
		        </el-form-item>
		        
		        <!--------按月份查找------------->
		        <el-form-item style="width:15%" v-if="flowquery.flowtype==2">
		            <el-date-picker v-model="flowquery.start" type="month" placeholder="开始月份" format="yyyy-MM" value-format="yyyy-MM-dd" style="width:100%" @change="flowselect=true"></el-date-picker>
		        </el-form-item>
		        <el-form-item style="width:15%" v-if="flowquery.flowtype==2">
		            <el-date-picker v-model="flowquery.end" type="month" placeholder="结束月份" format="yyyy-MM" value-format="yyyy-MM-dd" style="width:100%" @change="flowselect=true"></el-date-picker>
		        </el-form-item>
		        
		        <!--------按年份查找------------->
		        <el-form-item style="width:15%" v-if="flowquery.flowtype==1">
		            <el-date-picker v-model="flowquery.start" type="year" placeholder="开始年份" format="yyyy" value-format="yyyy-MM-dd" style="width:100%" @change="flowselect=true"></el-date-picker>
		        </el-form-item>
		        <el-form-item style="width:15%" v-if="flowquery.flowtype==1">
		            <el-date-picker v-model="flowquery.end" type="year" placeholder="结束年份" format="yyyy" value-format="yyyy-MM-dd" style="width:100%" @change="flowselect=true"></el-date-picker>
		        </el-form-item>		        
		  		<el-form-item>
		  			<el-button type="primary" icon="el-icon-search" @click="getflowdata">搜索</el-button>
		  			<el-button type="primary" @click="outdatas" :loading="outputLoading">导出</el-button>
		  		</el-form-item>
		  		<el-form-item v-if="flowquery.flowtype==3">
		  			<el-tag type="danger">注：按日期搜索经营流水时，最多不能超过90天的数据</el-tag>
		  		</el-form-item>
		  	</el-form>
		  	
		  	<el-table :data="flowdata" style="width: 100%" v-loading="flowLoading">
	        	<el-table-column label="序号" prop="sort" width="80" align="center"></el-table-column>
	        	<el-table-column label="时间维度" prop="time" width="100"></el-table-column>
	        	<el-table-column label="销售金额" prop="selltotals" width="100" align="center"></el-table-column>
	        	<el-table-column label="销售笔数" prop="sellnums" width="100" align="center"></el-table-column>
	        	<el-table-column label="退货金额" prop="refundtotals" width="100" align="center"></el-table-column>
	        	<el-table-column label="退货笔数" prop="refundnums" width="100" align="center"></el-table-column>
	        	<el-table-column label="销售毛利" prop="sellincome" width="100" align="center"></el-table-column>
	        	<el-table-column label="毛利率" prop="incomepercent" width="100" align="center"></el-table-column>
	        	<el-table-column label="首客数" prop="firstnums" width="100" align="center"></el-table-column>
	        	<el-table-column label="首客销售金额" prop="firstsells" width="100" align="center"></el-table-column>
	        	<el-table-column label="回购客户数" prop="againnums" width="100" align="center"></el-table-column>
	        	<el-table-column label="回购客户销售金额" prop="againsells" width="100" align="center"></el-table-column>
      		</el-table>
      		<div class="block">
            <!--分页begin-->
            <el-pagination
	            @size-change="flowPageSizeChange"
	            @current-change="flowPageCurrentChange"
	            :current-page="flowquery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="flowquery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="flow_rows">
            </el-pagination>
            <!--分页end-->
      		</div>		  	
	  	</el-dialog>
	  	
	  	<!---------------------------- 导出信息确认 ---------------------------->
	      <el-dialog title="导出信息确认" :visible.sync="outputDialog" width="90%" top="5vh">
	      	  <el-button size="medium" type="danger" @click="sureoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      	  <div id="outputorder">
		      	  <el-table :data="flowexportdata" border v-loading="exportLoading">
		      	  	  <el-table-column label="序号" prop="sort" width="80" align="center"></el-table-column>
		        	  <el-table-column label="时间维度" prop="time" width="100"></el-table-column>
		        	  <el-table-column label="销售金额" prop="selltotals" width="100" align="center"></el-table-column>
		        	  <el-table-column label="销售笔数" prop="sellnums" width="100" align="center"></el-table-column>
		        	  <el-table-column label="退货金额" prop="refundtotals" width="100" align="center"></el-table-column>
		        	  <el-table-column label="退货笔数" prop="refundnums" width="100" align="center"></el-table-column>
		        	  <el-table-column label="销售毛利" prop="sellincome" width="100" align="center"></el-table-column>
		        	  <el-table-column label="毛利率" prop="incomepercent" width="100" align="center"></el-table-column>
		        	  <el-table-column label="首客数" prop="firstnums" width="100" align="center"></el-table-column>
		        	  <el-table-column label="首客销售金额" prop="firstsells" width="100" align="center"></el-table-column>
		        	  <el-table-column label="回购客户数" prop="againnums" width="100" align="center"></el-table-column>
		        	  <el-table-column label="回购客户销售金额" prop="againsells" width="100" align="center"></el-table-column>	          	  	          	  
		      	  </el-table>
	      	  </div>
	      	  <div slot="footer" class="dialog-footer">
		          <el-button size="medium" @click="outputDialog=false">取 消</el-button>
		          <el-button size="medium" type="danger" @click="sureoutput">确认导出</el-button>
		      </div>	                
	      </el-dialog> 
    	    	
    </div>
    </transition>
</template>

<script>

export default {
    data () {
	    return {
	        url:this.GLOBAL.domain+"Datastat/index",
	        transitionshow:true,
	        actionauth:[],
	        query: {
	        	act:'managesale',
	      	    token:this.$cookies.get('token'),
	      	    start:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
	      	    end:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
	        },
	        saleLoading:false,
	        saledatas:[],
	        getquery: {
	        	act:'manageincome',
	      	    token:this.$cookies.get('token'),
	      	    start:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
	      	    end:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
	        },
	        getLoading:false,
	        incomedata:[],
	        emptyquery: {
	        	act:'emptyaccount',
	      	    token:this.$cookies.get('token'),
	      	    start:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
	      	    end:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
	        },
	        emptyLoading:false,
	        emptyaccounts:[],
	        noemptyquery: {
	        	act:'noemptyaccount',
	      	    token:this.$cookies.get('token'),
	      	    start:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
	      	    end:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
	        },
	        noemptyLoading:false,
	        noemptyaccounts:[],
	        flowquery: {
	        	act:'getflowdatas',
	      	    token:this.$cookies.get('token'),
	      	    start:'',
	      	    end:'',
	      	    p:1,
	      	    rollpage:10,
	      	    flowtype:3,
	      	    type:1, //是否分商信息分页 1、是（用于搜索）2、否（用于数据导出）
	        },
	        flowDialog:false,
	        flowLoading:false,
	        flowtype:[{id:1,name:'按年份'},{id:2,name:'按月份'},{id:3,name:'按日期'}],
	        flowdata:[],
	        flow_rows:0,
	        flowselect:false,
	        outputDialog:false,
	        outputLoading:false,
	        flowexportquery: {
	        	act:'getflowexportdatas',
	      	    token:this.$cookies.get('token'),
	      	    start:'',
	      	    end:'',
	      	    flowtype:3,
	      	    type:2, //是否分商信息分页 1、是（用于搜索）2、否（用于数据导出）
	        },
	        flowexportdata:[],
	    }
    },
    
    mounted(){
  		this.getactionauth(); //获取权限设置
  		this.getsalesdata(); //获取销售情况信息
  		this.getincome(); //收款情况
  		this.getemptyaccount(); //获取欠货两清信息
  		this.nogetemptyaccount(); //获取欠货未清信息
    },
    
    methods:{   
     
	    /** 获取操作功能权限 **/
	  	getactionauth() {
	    	var data =this.$cookies.get('actionauth');
	    	data=JSON.parse(data);
	        this.actionauth=data;
	    },
	    
	    
	    /** 获取今日、昨日、本月、本年数据 **/
	    getsalestypedata(type) {
	    	if(type==1) { //今日
	    		var nowday=new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate();  		   		
	    		this.query.start=nowday;
	    		this.query.end=nowday;
	    		
	    	}else if(type==2) { //昨日
	    		var myday=new Date(new Date() - 1000*60*60*24);
	    		var yesterday=myday.getFullYear().toString()+'-'+(myday.getMonth()+1)+'-'+myday.getDate();
	    		this.query.start=yesterday;
	    		this.query.end=yesterday;
	    	
	    	}else if(type==3) { //本月
	    		var nowDate = new Date();
				var cloneNowDate = new Date();
				var fullYear = nowDate.getFullYear();
				var month = nowDate.getMonth() + 1; // getMonth 方法返回 0-11，代表1-12月
				var endOfMonth = new Date(fullYear, month, 0).getDate(); // 获取本月最后一天
				var starDate = this.getFullDate(cloneNowDate.setDate(1));//当月第一天
				var endDate = this.getFullDate(cloneNowDate.setDate(endOfMonth));//当月最后一天
				this.query.start=starDate;
	    		this.query.end=endDate;
	    	
	    	}else if(type==4) { //本年
	    		var nowDate = new Date();
	    		var start=nowDate.getFullYear()+"-"+"01"+"-"+"01";
	    		var end=nowDate.getFullYear()+"-"+"12"+"-"+"31";
	    		this.query.start=start;
	    		this.query.end=end;
	    	}
	    
	    	this.getsalesdata(); //获取销售情况信息
	    	this.getincome(); //获取收款情况信息
	    	this.getemptyaccount(); //获取钱货两清信息
	    	this.nogetemptyaccount(); //获取欠货未清信息
	    },
	    
	    getFullDate(targetDate) {
	        var D, y, m, d;
	        if (targetDate) {
	            D = new Date(targetDate);
	            y = D.getFullYear();
	            m = D.getMonth() + 1;
	            d = D.getDate();
	        } else {
	            y = fullYear;
	            m = month;
	            d = date;
	        }
	        m = m > 9 ? m : '0' + m;
	        d = d > 9 ? d : '0' + d;
	        return y + '-' + m + '-' + d;
	    },
	    
	    search() {
	    	this.getsalesdata(); //获取销售情况信息
	  		this.getincome(); //收款情况
	  		this.getemptyaccount(); //获取钱货两清信息
	  		this.nogetemptyaccount(); //获取钱货未清信息
	    },
	    
	    /** 获取销售情况信息 **/
	    getsalesdata() {
	    	this.saleLoading=true;
			var resource = this.$resource(this.url);
	        resource.query(this.query).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.saleLoading=false;
		        }else{
		            this.saledatas = JSON.parse(Base64.decode(res.data.Data));
		            this.saleLoading=false;
		        }
	        }).catch((res) => {
	            this.saleLoading=false;
	        });	    
	    },
	    
	    /** 获取收款情况信息 **/
     	getincome() {
     		this.getquery.start=this.query.start;
     		this.getquery.end=this.query.end;
     		
     		this.getLoading=true;
			var resource = this.$resource(this.url);
	        resource.query(this.getquery).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.getLoading=false;
		        }else{
		            this.incomedata = JSON.parse(Base64.decode(res.data.Data));
		            this.getLoading=false;
		        }
	        }).catch((res) => {
	            this.getLoading=false;
	        });	
     	},
     	
     	/** 获取钱货两清数据 **/
     	getemptyaccount() {
     		this.emptyquery.start=this.query.start;
     		this.emptyquery.end=this.query.end;
     		
     		this.emptyLoading=true;
			var resource = this.$resource(this.url);
	        resource.query(this.emptyquery).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.emptyLoading=false;
		        }else{
		            this.emptyaccounts = JSON.parse(Base64.decode(res.data.Data));
		            this.emptyLoading=false;
		        }
	        }).catch((res) => {
	            this.emptyLoading=false;
	        });	
     	},
     	
     	/** 获取钱货未清信息 **/
     	nogetemptyaccount() {
     		this.noemptyquery.start=this.query.start;
     		this.noemptyquery.end=this.query.end;
     		
     		this.noemptyLoading=true;
			var resource = this.$resource(this.url);
	        resource.query(this.noemptyquery).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.noemptyLoading=false;
		        }else{
		            this.noemptyaccounts = JSON.parse(Base64.decode(res.data.Data));
		            this.noemptyLoading=false;
		        }
	        }).catch((res) => {
	            this.noemptyLoading=false;
	        });	
     	},
     	
     	/** 查看经营流水 **/
     	checkflow() {
     		this.$emit('listenchild',{name:'查看经营流水',url:'Managestatefund'});
     		return false;
     	
     		this.flowDialog=true;
     		this.flowquery.type=1;
     		this.flowquery.start='';
	    	this.flowquery.end='';
	    	this.flowselect=true;
     		this.flowdata=[];
     	},
     	
     	/** 获取经营流水数据 **/
     	getflowdata() {
     		if(this.flowselect==true) {
     			this.flowquery.p=1;
	    		this.flowquery.rollpage=10;
     		}
     	
     		this.flowLoading=true;
			var resource = this.$resource(this.url);
	        resource.query(this.flowquery).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.flowLoading=false;
		        }else{
		            this.flowdata = JSON.parse(Base64.decode(res.data.Data));
		            this.flow_rows=parseInt(res.data.count);
		            this.flowLoading=false;
		            if(this.flowselect==true) this.flowselect=false;
		        }
	        }).catch((res) => {
	            this.flowLoading=false;
	        });	
     	},
     	
     	flowPageSizeChange(val) {
        	this.flowquery.rollpage = val;
        	this.getflowdata();
	    },
	    flowPageCurrentChange(val) {
	        this.flowquery.p = val;
	        this.getflowdata();
	    },
	    
	    changedate() {
			this.flowquery.start='';
	    	this.flowquery.end='';
	    	this.flowselect=true;
	    },
	    
	    //导出经营流水
	    outdatas() {
	    	this.outputLoading=true;
	    	this.flowexportquery.start=this.flowquery.start;
	    	this.flowexportquery.end=this.flowquery.end;
	    	this.flowexportquery.flowtype=this.flowquery.flowtype;	  
	    	this.outputDialog=true;  	
	    	this.getflowexportdata();
		    this.outputLoading=false;
	    },
	    
	    /** 获取经营流水数据 **/
     	getflowexportdata() {
     		this.exportLoading=true;
			var resource = this.$resource(this.GLOBAL.exportUrl+'Datastat/index');
	        resource.query(this.flowexportquery).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.exportLoading=false;
		        }else{
		            this.flowexportdata = JSON.parse(Base64.decode(res.data.Data));
		            this.exportLoading=false;
		        }
	        }).catch((res) => {
	            this.exportLoading=false;
	        });	
     	},
	    
	    
	    /** 确认导出订单信息 **/
	    sureoutput() {
			require.ensure([], () => {			
				var { export_json_to_excel } = require('../../vendor/Export2Excel');
				var tHeader = ['序号','时间维度','销售金额','销售笔数','退货金额','退货笔数','销售毛利','毛利率','首客数','首客销售金额','回购客户数','回购客户销售金额'];
				var filterVal = ['sort','time','selltotals','sellnums','refundtotals','refundnums','sellincome','incomepercent','firstnums','firstsells','againnums','againsells'];
					
				var list = this.flowexportdata;
				var data = this.formatJson(filterVal, list);
				export_json_to_excel(tHeader, data, '经营流水');
				this.outputDialog=false;
			})
	    },
	    
	    //导出表格数据
		formatJson(filterVal, jsonData) {
	　　　　return jsonData.map(v => filterVal.map(j => v[j]));
	　　},
	    
     
    }
}
</script>

</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.menubutton:focus, .menubutton:hover {color:#fff;border-color:#409EFF;background-color:#409EFF}
.salesmain {padding:2% 2% 2% 2%;background:#fff;border-radius:5px;float:left;width:96%;}
.bordertitle {float:left;width:100%;}
.bordertitle img {float:left;width:4%;}
.bordertitle span {float:left;font-size:16px;margin-left:1%;padding:0.6% 0 0.6% 0;color:#606266;}
.bordermain {float:left;width:100%;}
.bordermain .single {float:left;width:16%;text-align:center;}
.bordermain .single span {float:left;width:100%;font-size:20px;text-align:center;font-weight:bold;color:#F56C6C;margin-top:12%}
.bordermain .single span i {font-size:14px;font-style:normal;}
.bordermain .single p {float:left;width:100%;text-align:center;font-size:14px;color:#909399;margin-top:3%}
.bordermain .double {float:left;width:20%;padding:0 1% 0 1%;text-align:center;background:#E4E7ED}
.bordermain .double table {float:left;width:100%;padding:10% 0 8% 0}
.bordermain .double table td {font-size:14px;color:#909399;}
.firstcustomer {font-style:normal;padding:2px 5px 2px 5px;border-radius:15px;color:#67C23A;background:#DCDFE6}
.secondcustomer {font-style:normal;padding:2px 5px 2px 5px;border-radius:15px;color:#E6A23C;background:#DCDFE6}
.double p {float:left;width:100%;margin-top:10%;text-align:center;font-size:14px;color:#909399}
.double p i {font-style:normal;color:#606266}
.percent {float:left;margin-top:3%;border-radius:15px;width:70%;height:10px;margin-bottom:8%;background:#C0C4CC}
.percent h {float:left;height:100%;background:#E6A23C;border-radius:15px}
.double em {font-style:normal;color:#606266;font-size:14px;float:left;line-height:22px;margin-left:5%}

.moneymain {padding:2% 2% 2% 2%;background:#fff;border-radius:5px;float:left;width:45.5%;}
.moneymain .bordertitle {float:left;width:100%;}
.moneymain .bordertitle img {float:left;width:8%;}
.moneymain .bordertitle span {float:left;font-size:16px;margin-left:2%;padding:1% 0 1% 0;color:#606266;}
.bordermain1 {float:left;width:100%;background:#E4E7ED;margin:3% 0 3% 0}
.bordermain1 .left {float:left;width:20%;height:100px;}
.bordermain1 .left span {float:left;width:100%;text-align:center;font-size:20px;color:#fff;margin-top:20px}
.bordermain1 .left span i {font-style:normal;font-size:14px;}
.bordermain1 .right {float:left;margin:20px 0 0 3%;width:77%}
.bordermain1 .right span {float:left;width:100%;margin-top:10px;font-size:14px;line-height:18px;color:#909399}
.bordermain1 .right span i {color:#606266;font-style:normal}
</style>


// WEBPACK FOOTER //
// src/components/stat/Managestate.vue